export default "__VITE_ASSET__dv9PcFLp__"